import React from 'react';
import styled from 'styled-components';
import PlayzoneFeature from '../components/featured/PlayzoneFeature';

const Wrapper = styled.div`
  min-height: 70vh;
  padding-top: var(--headerHeight);
  background-color: var(--darkBG);
`;

export default function PlayzonePage() {
  return (
    <Wrapper>
      <PlayzoneFeature />
    </Wrapper>
  );
}
